import type { EtaComputedPayload } from '../servicebus/eta';
import { ObjectFactory } from './object.factory';

export class EtaComputedPayloadFactory extends ObjectFactory<EtaComputedPayload> {
  protected getDefaults(): EtaComputedPayload {
    return {
      driverId: 'aabbccddeeff001122334455',
      queueId: 'bbccddeeff001122334455aa',
    };
  }
}

// Pre-instantiated for convenience
export const etaComputedPayloadFactory = new EtaComputedPayloadFactory();
